import { HttpHeaders } from '@angular/common/http';

import { ApiConfig } from './api-config';
import { catchError, map, Observable, throwError } from 'rxjs';
import { BEServerResponse } from '../../../common_resource_modules/models/global/BEServerResponse';

export class ApiUtils {
  public static getRequest(api: string) {
    const fullApi = `${ApiConfig.baseApiEndPoint}/${api}`;
    return {
      url: fullApi,
      header: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
  }

  public static getRequestWithFileSupport(api: string) {
    const fullApi = `${ApiConfig.baseApiEndPoint}/${api}`;
    return {
      url: fullApi,
      header: new HttpHeaders({
        enctype: 'multipart/form-data',
      }),
    };
  }
  public static getRequestV2(api: string) {
    const fullApi = `${ApiConfig.baseApiEndPointV2}/${api}`;
    return {
      url: fullApi,
      header: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
  }

  public static postRequest(api: string, body: any) {
    const fullApi = `${ApiConfig.baseApiEndPointV2}/${api}`;
    return {
      url: fullApi,
      body: body,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
  }
}
